export * from './BackgroundService';
export { BackgroundTaskOptions } from 'react-native-background-actions';
